import { createSlice, createAsyncThunk, current } from "@reduxjs/toolkit";
import { reviewUrls } from "./reviewUtils";
import { apiUrls } from "../../library/Utils";
import { saveAs } from "file-saver";

export const GetUserCountries = createAsyncThunk(
    "review/GetUserCountries",
    async (obj, { dispatch, getState }) => {
        let reqOptions = {};
        const data = JSON.parse(localStorage.getItem("data"));
        reqOptions.method = obj.method;
        let url = apiUrls.countryListUrl + data.userID;
        return fetch(url, reqOptions).then((r) => {
            return r.json();
        });
    }
);

export const GetOrderStatus = createAsyncThunk(
    "review/GetOrderStatus",
    async (obj, thunkAPI) => {
        const data = JSON.parse(localStorage.getItem("data"));
        const token = data.token;
        const userID = data.userID;
        const url = reviewUrls.orderStatus;
        try {
            const response = await fetch(url, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                    Accept: "application/json",
                },
            });
            const jsonData = await response.json();
            return jsonData;
        } catch (error) {
            console.error("Error: ", error);
        }
    }
);

export const GetCurrentWeek = createAsyncThunk(
    "review/GetCurrentWeek",
    async (obj, thunkAPI) => {
        const data = JSON.parse(localStorage.getItem("data"));
        const token = data.token;
        const userID = data.userID;
        const url = reviewUrls.GetCurrentWeek;
        try {
            const response = await fetch(url, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                    Accept: "application/json",
                },
            });
            const jsonData = await response.json();
            return jsonData;
        } catch (error) {
            console.error("Error: ", error);
        }
    }
);

export const GetScenarios = createAsyncThunk(
    "review/GetScenarios",
    async (obj, { dispatch, getState }) => {
        let reqOptions = {};
        const data = JSON.parse(localStorage.getItem("data"));
        const token = data.token;
        const userId = data.userID;
        let headers = new Headers();
        // headers.set("Access-Control-Allow-Origin", "*");
        // headers.append("Content-Type", "application/json");
        // headers.append("Accept", "application/json");
        if (token) {
            headers.append("Authorization", `Bearer ${token}`);
        }
        reqOptions.headers = headers;
        reqOptions.method = obj.method;
        let url = reviewUrls.scenarios + "countryId=" + obj.countryID + "&orderStatus=" + obj.orderStatus + "&searchText=" + obj.searchText + "&userId=" + userId + "&period=" + obj.period;
        return fetch(url, reqOptions).then((r) => {
            return r.json();
        });
    }
);

export const GetQuotaDetailsForScenario = createAsyncThunk(
    "review/GetQuotaDetailsForScenario",
    async (obj, { dispatch, getState }) => {
        let reqOptions = {};
        const data = JSON.parse(localStorage.getItem("data"));
        const token = data.token;
        const userId = data.userID;
        let headers = new Headers();
        // headers.set("Access-Control-Allow-Origin", "*");
        // headers.append("Content-Type", "application/json");
        // headers.append("Accept", "application/json");
        if (token) {
            headers.append("Authorization", `Bearer ${token}`);
        }
        reqOptions.headers = headers;
        reqOptions.method = obj.method;
        let url = reviewUrls.getQuotaDetailsForScenario + "scenarioId=" + obj.scenarioId + "&quotaId=" + obj.quotaId;
        return fetch(url, reqOptions).then((r) => {
            return r.json();
        });
    }
);

export const GetWeekStatus = createAsyncThunk(
    "review/GetWeekStatus",
    async (obj, { dispatch, getState }) => {
        let reqOptions = {};
        const data = JSON.parse(localStorage.getItem("data"));
        const token = data.token;
        const userId = data.userID;
        let headers = new Headers();
        // headers.set("Access-Control-Allow-Origin", "*");
        // headers.append("Content-Type", "application/json");
        // headers.append("Accept", "application/json");
        if (token) {
            headers.append("Authorization", `Bearer ${token}`);
        }
        reqOptions.headers = headers;
        reqOptions.method = obj.method;
        let url = reviewUrls.getWeekStatus + "QuotaStartDate=" + obj.quotaStartDate + "&QuotaEndDate=" + obj.quotaEndDate;
        return fetch(url, reqOptions).then((r) => {
            return r.json();
        });
    }
);

export const PostOrderDecision = createAsyncThunk(
    "review/PostOrderDecision",
    async (obj, { dispatch, getState }) => {
        const data = JSON.parse(localStorage.getItem("data"));
        const token = data.token;
        const url = reviewUrls.postOrderDecision;
        try {
            const response = await fetch(url, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                    Accept: "application/json",
                },
                body: JSON.stringify(obj),
            });
            const jsonData = await response.json();
            return jsonData;
        } catch (error) {
            console.error("Error: ", error);
        }
    }
);

export const StickToQuota = createAsyncThunk(
    "review/StickToQuota",
    async (obj, { dispatch, getState }) => {
        const data = JSON.parse(localStorage.getItem("data"));
        const token = data.token;
        const url = reviewUrls.StickToQuota;
        try {
            const response = await fetch(url, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                    Accept: "application/json",
                },
                body: JSON.stringify(obj),
            });
            const jsonData = await response.json();
            return jsonData;
        } catch (error) {
            console.error("Error: ", error);
        }
    }
);

export const DoNothingMarked = createAsyncThunk(
    "review/DoNothingMarked",
    async (obj, { dispatch, getState }) => {
        const data = JSON.parse(localStorage.getItem("data"));
        const token = data.token;
        const url = reviewUrls.DoNothing;
        try {
            const response = await fetch(url, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                    Accept: "application/json",
                },
                body: JSON.stringify(obj),
            });
            const jsonData = await response.json();
            return jsonData;
        } catch (error) {
            console.error("Error: ", error);
        }
    }
);

export const EditOrders = createAsyncThunk(
    "review/EditOrders",
    async (obj, { dispatch, getState }) => {
        const data = JSON.parse(localStorage.getItem("data"));
        const token = data.token;
        const url = reviewUrls.EditOrders;
        try {
            const response = await fetch(url, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                    Accept: "application/json",
                },
                body: JSON.stringify(obj),
            });
            const jsonData = await response.json();
            return jsonData;
        } catch (error) {
            console.error("Error: ", error);
        }
    }
);
export const UnblockFullOrderMSQ = createAsyncThunk(
    "review/UnblockFullOrderMSQ",
    async (obj, { dispatch, getState }) => {
        const data = JSON.parse(localStorage.getItem("data"));
        const token = data.token;
        const url = reviewUrls.UnblockFullOrderMSQ;
        try {
            const response = await fetch(url, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                    Accept: "application/json",
                },
                body: JSON.stringify(obj),
            });
            const jsonData = await response.json();
            return jsonData;
        } catch (error) {
            console.error("Error: ", error);
        }
    }
);
export const RecallModification = createAsyncThunk(
    "review/RecallModification",
    async (quotaId, thunkAPI) => {
        const data = JSON.parse(localStorage.getItem("data"));
        const token = data.token;
        const userID = data.userID;
        const url = reviewUrls.RecallModification + "quotaId=" + quotaId;
        try {
            const response = await fetch(url, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                    Accept: "application/json",
                },
            });
            const jsonData = await response.json();
            return jsonData;
        } catch (error) {
            console.error("Error: ", error);
        }
    }
);

export const GetModifiedOrders = createAsyncThunk(
    "review/GetModifiedOrders",
    async (obj, { dispatch, getState }) => {
        let reqOptions = {};
        const data = JSON.parse(localStorage.getItem("data"));
        const token = data.token;
        const userId = data.userID;
        let headers = new Headers();
        // headers.set("Access-Control-Allow-Origin", "*");
        // headers.append("Content-Type", "application/json");
        // headers.append("Accept", "application/json");
        if (token) {
            headers.append("Authorization", `Bearer ${token}`);
        }
        reqOptions.headers = headers;
        reqOptions.method = obj.method;
        let url = reviewUrls.getModifiedOrders + "countryId=" + obj.countryID + "&period=" + obj.period;
        return fetch(url, reqOptions).then((r) => {
            return r.json();
        });
    }
);

export const ExportFile_ModifiedOrders = createAsyncThunk(
    "review/ExportFile_ModifiedOrders",
    async (obj, thunkAPI) => {
        const data = JSON.parse(localStorage.getItem("data"));
        const token = data.token;
        const url = reviewUrls.exportFile + `countryId=${obj.countryID}&countryName=${obj.countryName}`;
        try {
            const response = await fetch(url, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                    Accept: "application/json",
                },
                //body: JSON.stringify(postBody),
            });
            const res = await response.blob();
            const extension = "xlsx";
            const fileName = `${obj.countryName} Modified Order.${extension}`;
            saveAs(res, fileName);
            return res;
        } catch (error) {
            console.error("Error: ", error);
        }
    }
);

export const DeleteModifiedOrders = createAsyncThunk(
    "review/DeleteModifiedOrders",
    async (obj, { dispatch, getState }) => {
        const data = JSON.parse(localStorage.getItem("data"));
        const token = data.token;
        const url = reviewUrls.deleteModifiedOrders;
        try {
            const response = await fetch(url, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                    Accept: "application/json",
                },
                body: JSON.stringify(obj),
            });
            const jsonData = await response.json();
            return jsonData;
        } catch (error) {
            console.error("Error: ", error);
        }
    }
);

export const GetOrders = createAsyncThunk(
    "orderModifications/GetOrders",
    async (obj, { dispatch, getState }) => {
        let reqOptions = {};
        const data = JSON.parse(localStorage.getItem("data"));
        const token = data.token;
        const userId = data.userID;
        let headers = new Headers();
        // headers.set("Access-Control-Allow-Origin", "*");
        // headers.append("Content-Type", "application/json");
        // headers.append("Accept", "application/json");
        if (token) {
            headers.append("Authorization", `Bearer ${token}`);
        }
        reqOptions.headers = headers;
        reqOptions.method = obj.method;
        let url = reviewUrls.getOrders + "countryId=" + obj.countryID + "&orderStatus=" + obj.orderStatus + "&period=" + obj.period;
        return fetch(url, reqOptions).then((r) => {
            return r.json();
        });
    }
);

export const SubmitOrderModificationStickToQuota = createAsyncThunk(
    "review/SubmitOrderModificationStickToQuota",
    async (obj, { dispatch, getState }) => {
        const data = JSON.parse(localStorage.getItem("data"));
        const token = data.token;
        const url = reviewUrls.submitOrderModifications;
        const myArr = [];
        myArr.push(obj);
        try {
            const response = await fetch(url, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                    Accept: "application/json",
                },
                body: JSON.stringify(myArr),
            });
            const jsonData = await response.json();
            return jsonData;
        } catch (error) {
            console.error("Error: ", error);
        }
    }
);

export const SubmitModification = createAsyncThunk(
    "review/SubmitModification",
    async (obj, { dispatch, getState }) => {
        const data = JSON.parse(localStorage.getItem("data"));
        const { filepath } = getState().review;
        let fileList = [...obj.quotaModificationFiles];
        if (obj.quotaModificationFiles !== undefined && obj.quotaModificationFiles.length > 0) {
            for (let i = 0; i < filepath.length; i++) {
                fileList.push(filepath[i]);
            }
        } else {
            fileList = []
            for (let i = 0; i < filepath.length; i++) {
                fileList.push(filepath[i]);
            }
        }
        let objList = { ...obj, quotaModificationFiles: fileList };
        const token = data.token;
        const url = reviewUrls.submitModification + "QuotaDifference=2&periodType=1";
        // const myArr = [];
        // myArr.push(obj);
        try {
            const response = await fetch(url, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                    Accept: "application/json",
                },
                body: JSON.stringify(objList),
            });
            const jsonData = await response.json();
            return jsonData;
        } catch (error) {
            console.error("Error: ", error);
        }
    }
);

export const ExportExcel = createAsyncThunk(
    "review/ExportExcel",
    async (obj, thunkAPI) => {
        const data = JSON.parse(localStorage.getItem("data"));
        const token = data.token;
        const url = reviewUrls.exportExcel;
        try {
            const response = await fetch(url, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                    Accept: "application/json",
                },
                body: JSON.stringify(obj),
            });
            const res = await response.blob();
            const extension = "xlsx";
            const fileName = `${obj.quotaConsumptionScenario.countryName}_${obj.quotaConsumptionScenario.scenarioName}_Review_Import.${extension}`;
            saveAs(res, fileName);
            return res;
        } catch (error) {
            console.error("Error: ", error);
        }
    }
);

export const ImportExcel = createAsyncThunk(
    "review/ImportExcel",
    async (formData, thunkAPI) => {
        const data = JSON.parse(localStorage.getItem("data"));
        const token = data.token;
        // const {
        //     countryName,
        //     scenarioName,
        //     depletion,
        //     formData
        // } = obj;
        const url = reviewUrls.importExcel;
        try {
            const response = await fetch(url, {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${token}`,
                    Accept: "application/json",
                    "Content-Disposition": "multipart/form-data",
                },
                body: formData,
            });
            const jsonData = await response.json();
            return jsonData;
        } catch (error) {
            console.error("Error: ", error);
        }
    }
);
export const DownloadFile = createAsyncThunk(
    "review/downloadfile",
    async (filepath, thunkAPI) => {
        const data = JSON.parse(localStorage.getItem("data"));
        const token = data.token;
        const url = reviewUrls.Downloadfile + `fileName=${filepath}`;
        try {
            const response = await fetch(url, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                    Accept: "application/json",
                },
            });
            const res = await response.blob();
            const fileName = filepath;
            saveAs(res, fileName);
            return res;
        } catch (error) {
            console.error("Error: ", error);
        }
    }
);


export const GetBlockedCustomersConsumptionforDecision = createAsyncThunk(
    "review/GetBlockedCustomersConsumptionforDecision",
    async (obj, thunkAPI) => {
        const data = JSON.parse(localStorage.getItem("data"));
        const token = data.token;

        const url = reviewUrls.getBlockedCustomersConsumption;
        try {
            const response = await fetch(url, {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${token}`,
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(obj),
            });
            const jsonData = await response.json();
            return jsonData;
        } catch (error) {
            console.error("Error: ", error);
        }
    }
);
export const GetBlockedCustomersConsumptionforMSQDecision = createAsyncThunk(
    "review/GetBlockedCustomersConsumptionforMSQDecision",
    async (obj, thunkAPI) => {
        const data = JSON.parse(localStorage.getItem("data"));
        const token = data.token;

        const url = reviewUrls.getBlockedCustomersConsumption;
        try {
            const response = await fetch(url, {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${token}`,
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(obj),
            });
            const jsonData = await response.json();
            return jsonData;
        } catch (error) {
            console.error("Error: ", error);
        }
    }
);
export const GetBlockedCustomersConsumption = createAsyncThunk(
    "review/GetBlockedCustomersConsumption",
    async (obj, thunkAPI) => {
        const data = JSON.parse(localStorage.getItem("data"));
        const token = data.token;

        const url = reviewUrls.getBlockedCustomersConsumption;
        try {
            const response = await fetch(url, {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${token}`,
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(obj),
            });
            const jsonData = await response.json();
            return jsonData;
        } catch (error) {
            console.error("Error: ", error);
        }
    }
);
export const Upload = createAsyncThunk(
    "review/Upload",
    async (obj, { dispatch, getState }) => {
        const { files } = getState().review;
        const data = JSON.parse(localStorage.getItem("data"));
        const token = data.token;
        const formData = new FormData();
        for (var i = 0; i < files.length; i++) {
            formData.append("files", files[i], files[i].name);
        }
        const url = reviewUrls.Upload;
        try {
            const response = await fetch(url, {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${token}`,
                    Accept: "application/json",
                    "Content-Disposition": "multipart/form-data",
                },
                body: formData,
            });
            const jsonData = await response.json();
            return jsonData;
        } catch (error) {
            console.error("Error: ", error);
        }
    }
);
export const SubmitOrderDecision = createAsyncThunk(
    "review/SubmitOrderDecision",
    async (obj, thunkAPI) => {
        const data = JSON.parse(localStorage.getItem("data"));
        const token = data.token;

        const url = reviewUrls.SubmitOrderDecision;
        try {
            const response = await fetch(url, {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${token}`,
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(obj),
            });
            const jsonData = await response.json();
            return jsonData;
        } catch (error) {
            console.error("Error: ", error);
        }
    }
);

export const GetModificationPreferences = createAsyncThunk(
    "review/GetModificationPreferences",
    async (userId, thunkAPI) => {
        const data = JSON.parse(localStorage.getItem("data"));
        const token = data.token;
        const userID = data.userID;
        const url = reviewUrls.GetModificationPreference + "?userId=" + userId;
        try {
            const response = await fetch(url, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                    Accept: "application/json",
                },
            });
            const jsonData = await response.json();
            return jsonData;
        } catch (error) {
            console.error("Error: ", error);
        }
    }
);


export const UpsertPreference = createAsyncThunk(
    "review/UpsertPreference",
    async (obj, thunkAPI) => {
        const data = JSON.parse(localStorage.getItem("data"));
        const token = data.token;

        const url = reviewUrls.UpsertPreference;
        try {
            const response = await fetch(url, {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${token}`,
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(obj),
            });
            const jsonData = await response.json();
            return jsonData;
        } catch (error) {
            console.error("Error: ", error);
        }
    }
);

const initialState = {
    isLoading: false,
    isSuccess: false,
    isFailed: false,
    isError: false,
    countries: [],
    selectedCountry: "All",
    selectedCountryID: 0,
    revGlobalCountryID:"",
    selectedScenario: "",
    selectedScenarioID: "",
    selectedQuotaID: "",
    orderStatus: [],
    selectedOrderStatus: "Everything but Normal",
    selectedPeriod: 1,
    getScenarios: [],
    getQuotaDetails: {},
    getWeekStatus: {},
    postOrderStatus: null,
    displayModification: false,
    quotaConsumptionTableState: [],
    checkedCustomersList: [],
    getModifiedOrders: [],
    exportResponse: null,
    deleteResponse: null,
    getOrders: [],
    postOrderModificationStatus: null,
    updatedWeeklyData: [],
    clearQCTable: false,
    excelData: {},
    submitModificationStatus: null,
    userComments: [],
    searchTxt: "",
    message: "",
    secondMessage: "",
    severity: "",
    messageOpen: false,
    secondMessageOpen: false,
    secondSeverity: "",
    isDisplayBlocked: false,
    modifyList: [],
    CustomerSearchTxt: "",
    ProductsSearchTxt: "",
    ModifiedList: [],
    files: [],
    filepath: [],
    isNavigate: false,
    clearMTable: false,
    CurrentWeek: "",
    NavValue: 0,
    isCollapseOpen: false,
    QCcustomerSearch: "",
    QCproductSearch: "",
    clearReviewTable: false,
    RecallList: [],
    preferenceList :{},
    selectedPreferenceLabels:[],
    isRecallClicked: false,
    customerList: [],
    customerListForDecision: [],
    TotalModifiedQtyUoM: 0,
    TotalAvailableQty: 0,
    openModifyOrders: false,
    orderParameters: {},
    omIsDisplayBlocked: false,
    onUnblockClicked: false,
    selectedCustomersForDecision: [],
    isCurrentWeekRowChanged: false,
    customerListForDecisionSubmission: [],
    modificationId: 0,
    onMSQClicked: false,
    onUnblockClickedSubmitted: false,
    isModifyClicked: false,
    isSubmitClicked: false,
    decisionCode : "",
    Code : "",
    isApproved : false,
    desSucPartmessage : "",
    desSucmessage: "",
    isDeleteClicked: false,
}

const reviewSlice = createSlice({
    name: "review",
    initialState,
    reducers: {
        setState: {
            prepare(stateName, stateValue) {
                return {
                    payload: { stateName, stateValue },
                };
            },
            reducer(state, action) {
                const { stateName, stateValue } = action.payload;
                state[stateName] = stateValue;
            },
        },
        addFile(state, action) {
            console.log(action.payload);
            const updatedFiles = [...state.files, action.payload];
            console.log(updatedFiles);
            state.files = updatedFiles;
        },
        deleteFile(state, action) {
            const { name, size } = action.payload;
            const updatedFiles = state.files.filter((file) => file.name !== name);
            state.files = updatedFiles;
        },
        deleteExistingFile(state, action){
            const { filePath } = action.payload;
            const updatedFiles = state.ModifiedList?.quotaModificationFiles.filter((file) => file.filePath !== filePath);
            state.ModifiedList.quotaModificationFiles = updatedFiles;
        },
        updateWeeklyData(state, action) {
            let updatedState = [...state.updatedWeeklyData];
            const updated = () => {
                return updatedState.map((customer) => {
                    if (customer.customerQuotaID === action.payload.customerQuotaID) {
                        return {
                            ...customer,
                            newFinalQuota: {
                                ...customer.newFinalQuota,
                                [action.payload.key1]: action.payload.value1
                            },
                            deltaModification: {
                                ...customer.deltaModification,
                                [action.payload.key1]: action.payload.value2
                            }
                        };
                    }
                    return customer;
                })
            }
            let updatedlist = updated();
            state.updatedWeeklyData = updatedlist;
        },
        reset(state, action) {
            if (action.payload === "refresh") {
                state.selectedCountry = "All";
                state.selectedCountryID = 0;
                state.selectedScenario = "";
                state.selectedScenarioID = "";
                state.selectedQuotaID = "";
                state.selectedOrderStatus = "Everything but Normal";
                state.selectedPeriod = 1;
                state.getScenarios = [];
                state.getQuotaDetails = {};
                state.getWeekStatus = {};
                state.postOrderStatus = null;
                state.displayModification = false;
                state.quotaConsumptionTableState = [];
                state.checkedCustomersList = [];
                state.getModifiedOrders = [];
                state.exportResponse = null;
                state.deleteResponse = null;
                state.postOrderModificationStatus = null;
                state.updatedWeeklyData = [];
                state.clearQCTable = false;
                state.excelData = {};
                state.submitModificationStatus = null;
                state.userComments = [];
                state.searchTxt = "";
                state.isDisplayBlocked = false;
                state.modifyList = [];
                state.CustomerSearchTxt = "";
                state.ProductsSearchTxt = "";
                state.ModifiedList = [];
                state.files = [];
                state.filepath = [];
                state.QCcustomerSearch = "";
                state.QCproductSearch = "";
                state.isCollapseOpen = false;
                state.clearReviewTable = false;
                state.customerList = [];
                state.TotalModifiedQtyUoM = 0;
                state.TotalAvailableQty = 0;
                state.orderParameters = {};
                state.omIsDisplayBlocked = false;
                state.customerListForDecision = [];
                state.customerListForDecisionSubmission = [];
                state.openModifyOrders = false;
                state.onUnblockClicked = false;
                state.selectedCustomersForDecision = [];
                state.isCurrentWeekRowChanged = false;
                state.onMSQClicked = false;
                state.RecallList = [];
            }
            else if (action.payload === "navigate") {
                state.getQuotaDetails = {};
                state.getWeekStatus = {};
                state.postOrderStatus = null;
                state.displayModification = false;
                state.quotaConsumptionTableState = [];
                state.checkedCustomersList = [];
                state.getModifiedOrders = [];
                state.exportResponse = null;
                state.deleteResponse = null;
                state.postOrderModificationStatus = null;
                state.updatedWeeklyData = [];
                state.clearQCTable = false;
                state.excelData = {};
                state.submitModificationStatus = null;
                state.userComments = [];
                state.isDisplayBlocked = false;
                state.modifyList = [];
                state.CustomerSearchTxt = "";
                state.ProductsSearchTxt = "";
                state.ModifiedList = [];
                state.files = [];
                state.filepath = [];
                state.customerList = [];
                state.TotalModifiedQtyUoM = 0;
                state.TotalAvailableQty = 0;
                state.orderParameters = {};
                state.customerListForDecision = [];
                state.customerListForDecisionSubmission = [];
                state.openModifyOrders = false;
                state.onUnblockClicked = false;
                state.onMSQClicked = false;
                state.selectedCustomersForDecision = [];
                state.isCurrentWeekRowChanged = false;
                state.RecallList = [];
            }
            else if (action.payload === "clear") {
                state.getQuotaDetails = {};
                state.getWeekStatus = {};
                state.postOrderStatus = null;
                state.displayModification = false;
                state.quotaConsumptionTableState = [];
                state.checkedCustomersList = [];
                state.getModifiedOrders = [];
                state.exportResponse = null;
                state.deleteResponse = null;
                state.postOrderModificationStatus = null;
                state.updatedWeeklyData = [];
                state.clearQCTable = false;
                state.excelData = {};
                state.submitModificationStatus = null;
                state.userComments = [];
                state.isDisplayBlocked = false;
                state.modifyList = [];
                state.CustomerSearchTxt = "";
                state.ProductsSearchTxt = "";
                state.ModifiedList = [];
                state.files = [];
                state.filepath = [];
                state.QCcustomerSearch = "";
                state.QCproductSearch = "";
                state.isCollapseOpen = false;
                state.clearReviewTable = false;
                state.customerList = [];
                state.TotalModifiedQtyUoM = 0;
                state.TotalAvailableQty = 0;
                state.orderParameters = {};
                state.omIsDisplayBlocked = false;
                state.customerListForDecision = [];
                state.customerListForDecisionForSubmission = [];
                state.openModifyOrders = false;
                state.selectedCustomersForDecision = [];
                state.isCurrentWeekRowChanged = false;
                state.RecallList = [];
            } else if (action.payload === 'refresh OrderDecision') {
                state.selectedCountry = "";
                state.selectedCountryID = null;
                state.getModifiedOrders = [];
                state.selectedPeriod = 1;
                state.isCollapseOpen = false;
                state.QCcustomerSearch = "";
                state.QCproductSearch = "";
            } else if (action.payload === 'refresh orderModification') {
                state.selectedCountry = "";
                state.selectedCountryID = null;
                state.getModifiedOrders = [];
                state.getOrders = [];
                state.selectedPeriod = 1;
                state.isCollapseOpen = false;
                state.clearReviewTable = false;
                state.QCcustomerSearch = "";
                state.QCproductSearch = "";
            }
        }
    },
    extraReducers: (builder) => {
        builder.addCase(GetUserCountries.pending, (state, action) => {
            state.isLoading = true;
        }).
            addCase(GetUserCountries.fulfilled, (state, { payload }) => {
                state.countries = payload;
                state.isLoading = false;
            }).addCase(GetUserCountries.rejected, (state, action) => {
                state.isLoading = false;
                console.log("Error from GetUserCountries", action.error.message);
            }).addCase(GetOrderStatus.pending, (state, action) => {
                state.isLoading = true;
            }).addCase(GetOrderStatus.fulfilled, (state, { payload }) => {
                state.orderStatus = payload;
                state.isLoading = false;
            }).addCase(GetOrderStatus.rejected, (state, action) => {
                state.isLoading = false;
                console.log("Error from GetOrderStatus", action.error.message);
            }).addCase(GetCurrentWeek.pending, (state, action) => {
                state.isLoading = true;
            }).addCase(GetCurrentWeek.fulfilled, (state, { payload }) => {
                state.CurrentWeek = payload;
                state.isLoading = false;
            }).addCase(GetCurrentWeek.rejected, (state, action) => {
                state.isLoading = false;
                console.log("Error from GetCurrentWeek", action.error.message);
            }).addCase(GetScenarios.pending, (state, action) => {
                state.isLoading = true;
            }).addCase(GetScenarios.fulfilled, (state, { payload }) => {
                state.getScenarios = payload;
                if (payload.length === 0) {
                    state.messageOpen = true;
                    state.message = "No records found for the selected criteria.";
                    state.severity = "info";
                }
                state.isLoading = false;
            }).addCase(GetScenarios.rejected, (state, action) => {
                state.isLoading = false;
                console.log("Error from GetScenarios", action.error.message);
            })
            .addCase(GetQuotaDetailsForScenario.pending, (state, action) => {
                state.isLoading = true;
            }).addCase(GetQuotaDetailsForScenario.fulfilled, (state, { payload }) => {
                state.getQuotaDetails = payload;
                if (payload.length === 0) {
                    state.messageOpen = true;
                    state.message = "No records found for the selected criteria.";
                    state.severity = "info";
                }
                state.ModifiedList = payload;
                state.isLoading = false;
            }).addCase(GetQuotaDetailsForScenario.rejected, (state, action) => {
                state.isLoading = false;
                console.log("Error from GetQuotaDetailsForScenario", action.error.message);
            })

            .addCase(GetWeekStatus.pending, (state, action) => {
                //state.isLoading = true;
            }).addCase(GetWeekStatus.fulfilled, (state, { payload }) => {
                state.getWeekStatus = payload;
                //state.isLoading = false;
            }).addCase(GetWeekStatus.rejected, (state, action) => {
                //state.isLoading = false;
                console.log("Error from GetWeekStatus", action.error.message);
            })

            .addCase(PostOrderDecision.pending, (state, action) => {
                state.isLoading = true;
            }).addCase(PostOrderDecision.fulfilled, (state, { payload }) => {
                state.postOrderStatus = payload;
                state.isLoading = false;
            }).addCase(PostOrderDecision.rejected, (state, action) => {
                state.isLoading = false;
                console.log("Error from PostOrderDecision", action.error.message);
            })

            .addCase(GetModifiedOrders.pending, (state, action) => {
                state.isLoading = true;
            }).addCase(GetModifiedOrders.fulfilled, (state, { payload }) => {
                state.getModifiedOrders = payload;
                if(!state.isDeleteClicked){
                    if (payload.length === 0) {
                        state.messageOpen = true;
                        state.message = "No records found for the selected criteria.";
                        state.severity = "info";
                    }
                }
                state.isLoading = false;
            }).addCase(GetModifiedOrders.rejected, (state, action) => {
                state.isLoading = false;
                console.log("Error from GetModifiedOrders", action.error.message);
            })

            .addCase(ExportFile_ModifiedOrders.pending, (state, action) => {
                state.isLoading = true;
            })
            .addCase(ExportFile_ModifiedOrders.fulfilled, (state, action) => {
                state.exportResponse = action.payload;
                state.isLoading = false;
            })
            .addCase(ExportFile_ModifiedOrders.rejected, (state, action) => {
                state.isLoading = false;
                console.error(
                    "Error from ExportFile_ModifiedOrders",
                    action.error.message
                );
            })

            .addCase(DeleteModifiedOrders.pending, (state, action) => {
                state.isLoading = true;
            })
            .addCase(DeleteModifiedOrders.fulfilled, (state, action) => {
                state.deleteResponse = action.payload;
                if (action.payload > 0) {
                    state.messageOpen = true;
                    state.message = "Deleted record(s) successfully.";
                    state.severity = "success";
                } else {
                    state.messageOpen = true;
                    state.message = "Not deleted some error occured.";
                    state.severity = "error";
                }
                state.isLoading = false;
            })
            .addCase(DeleteModifiedOrders.rejected, (state, action) => {
                state.isLoading = false;
                console.error(
                    "Error from DeleteModifiedOrders",
                    action.error.message
                );
                state.messageOpen = true;
                state.message = "Not deleted some error occured.";
                state.severity = "error";
            })

            .addCase(GetOrders.pending, (state, action) => {
                state.isLoading = true;
            })
            .addCase(GetOrders.fulfilled, (state, action) => {
                state.getOrders = action.payload;
                state.isLoading = false;
                if (action.payload?.quotaCusumptionCustomers.length === 0) {
                    if (state.isSubmitClicked == false) {
                        state.messageOpen = true;
                        state.message = "No records found for the selected criteria.";
                        state.severity = "info";
                    }
                    state.isSubmitClicked = false
                };
            })
            .addCase(GetOrders.rejected, (state, action) => {
                state.isLoading = false;
                console.error(
                    "Error from GetOrders",
                    action.error.message
                );
            })

            .addCase(SubmitOrderModificationStickToQuota.pending, (state, action) => {
                state.isLoading = true;
            })
            .addCase(SubmitOrderModificationStickToQuota.fulfilled, (state, action) => {
                state.postOrderModificationStatus = action.payload;
                if (typeof (action.payload) == 'string') {
                    state.messageOpen = true;
                    state.message = action.payload;
                    state.severity = "error";
                } else if (action.payload == true) {
                    state.messageOpen = true;
                    state.message = "Order decision(s) updated successfully."
                    state.severity = "success";
                } else {
                    state.messageOpen = true;
                    state.message = "Order decision(s) update failed for customer(s)."
                    state.severity = "error";
                }
                state.isLoading = false;
            })
            .addCase(SubmitOrderModificationStickToQuota.rejected, (state, action) => {
                state.isLoading = false;
                console.error(
                    "Error from SubmitOrderModificationStickToQuota",
                    action.error.message
                );
            }).addCase(DoNothingMarked.pending, (state, action) => {
                state.isLoading = true;
            })
            .addCase(DoNothingMarked.fulfilled, (state, action) => {
                state.postOrderModificationStatus = action.payload;
                if (typeof (action.payload) == 'string') {
                    state.messageOpen = true;
                    state.message = action.payload;
                    state.severity = "error";
                } else if (action.payload == true) {
                    state.messageOpen = true;
                    state.message = "Marked as reviewed successfully."
                    state.severity = "success";
                } else {
                    state.messageOpen = true;
                    state.message = "Marking as reviewed failed."
                    state.severity = "error";
                }
                state.isLoading = false;
            })
            .addCase(DoNothingMarked.rejected, (state, action) => {
                state.isLoading = false;
                console.error(
                    "Error from DoNothingMarked",
                    action.error.message
                );
            })

            .addCase(ImportExcel.pending, (state, action) => {
                state.isLoading = true;
            })
            .addCase(ImportExcel.fulfilled, (state, action) => {
                state.excelData = action.payload;
                if(typeof action.payload === "string"){
                    state.messageOpen = true;
                    state.message = "Invalid file or No Record."
                    state.severity = "error";
                }
                if(typeof action.payload === "object"){
                    state.messageOpen = true;
                    state.message = "Customer data imported successfully."
                    state.severity = "success";
                }
                state.isLoading = false;
            })
            .addCase(ImportExcel.rejected, (state, action) => {
                state.isLoading = false;
                console.error(
                    "Error from ImportExcel",
                    action.error.message
                );
            })

            .addCase(SubmitModification.pending, (state, action) => {
                state.isLoading = true;
            })
            .addCase(SubmitModification.fulfilled, (state, action) => {
                state.submitModificationStatus = action.payload;
                let result = "";
                state.isLoading = false;
                if (typeof (action.payload) == "object") {
                    result = action.payload.data.toString();
                    state.modificationId = action.payload.modificationID;
                } else {
                    result = action.payload;
                }
                if (result != "true" && result != "Approved") {
                    if (typeof result == "string") {
                        state.messageOpen = true;
                        state.message = result;
                        state.severity = "error";
                    } else {
                        state.messageOpen = true;
                        state.message = "Modifications submission failed.";
                        state.severity = "error";
                    }
                } else {
                    if(state.onUnblockClicked || state.onMSQClicked){
                        if (result == "Approved") {
                            state.isApproved = true;
                        } else {
                            state.isApproved = false;
                        }
                    }else{
                        if (result == "Approved") {
                            state.messageOpen = true;
                            state.message = "Modifications submitted successfully.";
                            state.severity = "success";
                        } else {
                            state.secondMessageOpen = true;
                            state.secondMessage = "Will be released once quota modification is approved.";
                            state.secondSeverity = "warning";
                            state.messageOpen = true;
                            state.message = "Modifications submitted successfully.";
                            state.severity = "success";
                        }
                    }
                }
            })
            .addCase(SubmitModification.rejected, (state, action) => {
                state.isLoading = false;
                console.error(
                    "Error from ImportExcel",
                    action.error.message
                );
            })

            .addCase(DownloadFile.pending, (state, action) => {
                state.isLoading = true;
            })
            .addCase(DownloadFile.fulfilled, (state, { payload }) => {
                state.isLoading = false;
            })
            .addCase(DownloadFile.rejected, (state, action) => {
                state.isLoading = false;
                console.error(
                    "Error from DownloadFile",
                    action.error.message
                );
            })

            .addCase(Upload.pending, (state, action) => {
                state.isLoading = true;
            })
            .addCase(Upload.fulfilled, (state, { payload }) => {
                state.isLoading = false;
                state.filepath = payload;
                state.files = [];
            })
            .addCase(Upload.rejected, (state, action) => {
                state.isLoading = false;
                console.error(
                    "Error from Upload",
                    action.error.message
                );
            }).addCase(RecallModification.pending, (state, action) => {
                state.isLoading = true;
            }).addCase(RecallModification.fulfilled, (state, { payload }) => {
                state.RecallList = payload;
                state.isLoading = false;
                state.messageOpen = true;
                state.message = "Recalled modification successfully.";
                state.severity = "success";
            }).addCase(RecallModification.rejected, (state, action) => {
                state.isLoading = false;
                console.log("Error from RecallModification", action.error.message);
                state.messageOpen = true;
                state.message = "Error during modification recall.";
                state.severity = "error";
            })
            .addCase(GetModificationPreferences.pending, (state, action) => {
                //state.isLoading = true;
            }).addCase(GetModificationPreferences.fulfilled, (state, { payload }) => {
                state.preferenceList = payload;

                const map = {
                    NewFinalQuota: "New Final Quota",
                    DeltaModifications: "Delta Modifications",
                    LastApprovedModification: "Last Approved Modification",
                    InitialQuota: "Initial Quota",
                };
            
                const selected = [];
            
                for (const [key, label] of Object.entries(map)) {
                    if (payload[key.charAt(0).toLowerCase() + key.slice(1)]) {
                        selected.push(label);
                    }
                }
            
                state.selectedPreferenceLabels = selected;
                //state.isLoading = false;
            }).addCase(GetModificationPreferences.rejected, (state, action) => {
                //state.isLoading = false;
                console.log("Error from GetModificationPreferences", action.error.message);
            })
            .addCase(UpsertPreference.pending, (state, action) => {
                //state.isLoading = true;
            }).addCase(UpsertPreference.fulfilled, (state, { payload }) => {
                state.isLoading = false;
            }).addCase(UpsertPreference.rejected, (state, action) => {
                state.isLoading = false;
                console.log("Error from UpsertPreference", action.error.message);
            }).addCase(StickToQuota.pending, (state, action) => {
                state.isLoading = true;
            }).addCase(StickToQuota.fulfilled, (state, action) => {
                state.isLoading = false;
                if (typeof (action.payload) == 'string') {
                    state.messageOpen = true;
                    state.message = action.payload;
                    state.severity = "error";
                } else if (action.payload === true) {
                    state.messageOpen = true;
                    state.message = "Orders modified successfully. Now export the modified orders and email them to customer service.";
                    state.severity = "success";
                } else {
                    state.messageOpen = true;
                    state.message = "Orders modification failed for customer(s).";
                    state.severity = "error";
                }
            }).addCase(StickToQuota.rejected, (state, action) => {
                state.isLoading = false;
                console.log("Error from StickToQuota", action.error.message);
                state.messageOpen = true;
                state.message = "Orders modification failed for customer(s).";
                state.severity = "error";
            }).addCase(GetBlockedCustomersConsumption.pending, (state, action) => {
                state.isLoading = true;
            }).addCase(GetBlockedCustomersConsumption.fulfilled, (state, action) => {
                state.isLoading = false;
                state.customerList = action.payload;
                state.TotalModifiedQtyUoM = action.payload.reduce(
                    (total, element) => total + parseFloat(element.modifiedQtyUoM),
                    0
                );
                state.TotalAvailableQty = action.payload.reduce(
                    (total, element) => total + parseFloat(element.availableQuota),
                    0
                );
            }).addCase(GetBlockedCustomersConsumption.rejected, (state, action) => {
                state.isLoading = false;
                console.log("Error from GetBlockedCustomersConsumption", action.error.message);
                state.messageOpen = true;
                state.message = "Error Occured in fetching data.";
                state.severity = "error";
            }).addCase(GetBlockedCustomersConsumptionforDecision.pending, (state, action) => {
                state.isLoading = true;
            }).addCase(GetBlockedCustomersConsumptionforDecision.fulfilled, (state, action) => {
                state.isLoading = false;
                state.customerListForDecision = action.payload;
                state.TotalModifiedQtyUoM = action.payload.reduce(
                    (total, element) => total + parseFloat(element.modifiedQtyUoM),
                    0
                );
                state.TotalAvailableQty = action.payload.reduce(
                    (total, element) => total + parseFloat(element.availableQuota),
                    0
                );
            }).addCase(GetBlockedCustomersConsumptionforDecision.rejected, (state, action) => {
                state.isLoading = false;
                console.log("Error from GetBlockedCustomersConsumptionforDecision", action.error.message);
                state.messageOpen = true;
                state.message = "Error Occured in fetching data.";
                state.severity = "error";
            }).addCase(GetBlockedCustomersConsumptionforMSQDecision.pending, (state, action) => {
                state.isLoading = true;
            }).addCase(GetBlockedCustomersConsumptionforMSQDecision.fulfilled, (state, action) => {
                state.isLoading = false;
                state.customerListForDecision = action.payload;
                state.TotalModifiedQtyUoM = action.payload.reduce(
                    (total, element) => total + parseFloat(element.modifiedQtyUoM),
                    0
                );
                state.TotalAvailableQty = action.payload.reduce(
                    (total, element) => total + parseFloat(element.availableQuota),
                    0
                );
            }).addCase(GetBlockedCustomersConsumptionforMSQDecision.rejected, (state, action) => {
                state.isLoading = false;
                console.log("Error from GetBlockedCustomersConsumptionforMSQDecision", action.error.message);
                state.messageOpen = true;
                state.message = "Error Occured in fetching data.";
                state.severity = "error";
            }).addCase(EditOrders.pending, (state, action) => {
                state.isLoading = true;
            }).addCase(EditOrders.fulfilled, (state, action) => {
                state.isLoading = false;
                if (typeof (action.payload) == 'string') {
                    state.messageOpen = true;
                    state.message = action.payload;
                    state.severity = "error";
                } else if (action.payload === true) {
                    state.messageOpen = true;
                    state.message = "Orders modified successfully. Now export the modified orders and email them to customer service.";
                    state.severity = "success";
                } else {
                    state.messageOpen = true;
                    state.message = "Orders modification failed for customer(s).";
                    state.severity = "error";
                }
            }).addCase(EditOrders.rejected, (state, action) => {
                state.isLoading = false;
                console.log("Error from EditOrders", action.error.message);
                state.messageOpen = true;
                state.message = "Orders modification failed for customer(s).";
                state.severity = "error";
            }).addCase(UnblockFullOrderMSQ.pending, (state, action) => {
                state.isLoading = true;
            }).addCase(UnblockFullOrderMSQ.fulfilled, (state, action) => {
                state.isLoading = false;
                if (typeof (action.payload) == 'string') {
                    state.messageOpen = true;
                    state.message = action.payload;
                    state.severity = "error";
                } else if (action.payload === true) {
                    // state.messageOpen = true;
                    // state.message = "Orders modified successfully. Now export the modified orders and email them to customer service.";
                    // state.severity = "success";
                } else {
                    state.messageOpen = true;
                    state.message = "Orders modification failed for customer(s).";
                    state.severity = "error";
                }
            }).addCase(UnblockFullOrderMSQ.rejected, (state, action) => {
                state.isLoading = false;
                console.log("Error from UnblockFullOrderMSQ", action.error.message);
                state.messageOpen = true;
                state.message = "Orders modification failed for customer(s).";
                state.severity = "error";
            }).addCase(SubmitOrderDecision.pending, (state, action) => {
                state.isLoading = true;
            }).addCase(SubmitOrderDecision.fulfilled, (state, action) => {
                state.isLoading = false;
                if (typeof action.payload === 'string') {
                    state.messageOpen = true;
                    state.message = action.payload;
                    state.severity = "error";
                } else {
                    if (action.payload) {
                        if (state.Code === 'fullorder' || state.Code === 'stickModify') {
                            if (!state.isApproved) {
                                state.secondMessageOpen = true;
                                state.secondMessage = "Will be released once quota modification is approved.";
                                state.secondSeverity = "warning";
                            }
                            state.messageOpen = true;
                            state.message = "Modifications and Decision updated successfully.";
                            state.severity = "success";
                        } else {
                            state.messageOpen = true;
                            state.message = state.desSucmessage;
                            state.severity = "success";
                        }
                    } else {
                        if (state.Code === 'fullorder' || state.Code === 'stickModify') {
                            if (!state.isApproved) {
                                state.secondMessageOpen = true;
                                state.secondMessage = "Will be released once quota modification is approved.";
                                state.secondSeverity = "warning";
                            }
                            state.messageOpen = true;
                            state.message = "Modifications and Decision updated successfully.";
                            state.severity = "success";

                        } else {
                            state.messageOpen = true;
                            state.message = state.desSucPartmessage;
                            state.severity = "success";
                        }
                    }
                }
            }).addCase(SubmitOrderDecision.rejected, (state, action) => {
                state.isLoading = false;
                console.log("Error from SubmitOrderDecision", action.error.message);
                state.messageOpen = true;
                state.message = "Error Occured in fetching data.";
                state.severity = "error";
            })
    }
});

export const {
    // setCountries,
    setState, addFile, deleteFile, reset, updateWeeklyData, deleteExistingFile
} = reviewSlice.actions;

export default reviewSlice.reducer;